import { useState, useCallback } from 'react';
import quarkusApi from '../../../../../api/quarkusApi';

export function useSaveEvolution() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((procedureId, evolution) => {
    setSaving(true);
    return quarkusApi
      .post(`/procedures/${procedureId}/evolutions`, evolution, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
